import { render, staticRenderFns } from "./editButton.vue?vue&type=template&id=963a1456&scoped=true&"
import script from "./editButton.vue?vue&type=script&lang=js&"
export * from "./editButton.vue?vue&type=script&lang=js&"
import style0 from "./editButton.vue?vue&type=style&index=0&id=963a1456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a1456",
  null
  
)

export default component.exports